import React from "react";

import { useProjectResourcesRetrieval } from "@planzone/view-models";
import { Identifiable, ProjectResource } from "@planzone/dto";
import { AddAllocationIcon } from "@common/assets/addAllocationIcon";
import { SelectList } from "@common/selectList";
import { ResourceAllocationMenu } from "@common/resourceAllocationMenu";
import { Props } from "./types";
import styles from "./styles.scss";

function ProjectResourceSelect({
  project,
  projectResources: groupMembers,
  addResources,
  removeResources,
  addEveryone,
  isEveryonePending,
}: Props) {
  const { projectResources } = useProjectResourcesRetrieval(project);

  return (
    <div className={styles.container}>
      <SelectList listClassName={styles.list} multiple>
        {() => ({
          input: <AddAllocationIcon className={styles.icon} />,
          list: (
            <div className={styles.scrollContainer}>
              <ResourceAllocationMenu
                allocatedResources={groupMembers.map(
                  ({ resource }) => resource,
                )}
                select={(resources) => {
                  addResources(
                    resources
                      .map(({ uuid }) =>
                        projectResources.find(
                          ({ resource }) => resource.uuid === uuid,
                        ),
                      )
                      .filter((r) => !!r) as Identifiable<ProjectResource>[],
                  );
                }}
                unSelect={(resources) => {
                  removeResources(
                    resources
                      .map(({ uuid }) =>
                        projectResources.find(
                          ({ resource }) => resource.uuid === uuid,
                        ),
                      )
                      .filter((r) => !!r) as Identifiable<ProjectResource>[],
                  );
                }}
                everyone={{ select: addEveryone, isPending: isEveryonePending }}
                openedViews={["resources"]}
              />
            </div>
          ),
        })}
      </SelectList>
    </div>
  );
}

export { ProjectResourceSelect };
